const _ = require('lodash');
const CARD_VIEW_MODE = {
    VIEW_ONLY: 'card-view',
    REPORT: 'card-report'
};

const getBadge = (review, isSyndicateReview) => {
    if (review.reviewAsStaffMember && !isSyndicateReview) {
        return {
            className: 'review-card--ribbon-team-member',
            label: 'BWS TEAM'
        };
    } else if (review.isFeatured) {
        return {
            className: 'review-card--ribbon-featured',
            label: 'FEATURED'
        };
    }

    return {
        className: '',
        label: ''
    };
};

function ReviewCardDirective(ReviewService, BazaarvoiceService, SettingsService, CurrentUserService, $state, hyphenate) {
    return {
        restrict: 'E',
        scope: {
            review: '='
        },
        template: require('./review-card-template.html'),
        link(scope) {
            scope.isSyndicateReview = scope.review.SourceClient !== 'bws';
            scope.ctrlId = _.uniqueId('review-card');
            scope.hyphenate = hyphenate;
            scope.vote = { direction: '' };
            scope.badge = getBadge(scope.review, scope.isSyndicateReview);
            scope.hasVoted = false;
            scope.hasReported = false;
            scope.voteLabel = '';
            scope.$state = $state;
            const user = scope.user = CurrentUserService.get();
            scope.view = CARD_VIEW_MODE.VIEW_ONLY;
            SettingsService.getSettingValue('BazaarVoice', 'BazaarvoiceApiCallEnabled').then(function (setting) {
                scope.bazaarvoiceApiCallEnabled = setting || false;
            });
            scope.helpfulVote = (helpful) => {
                if (scope.hasVoted) return;
                const direction = (helpful) ? 'up' : 'down';
                const yesNo = (helpful) ? 'yes' : 'no';
                scope.vote.direction = direction;
                scope.review.helpful[yesNo]++;
                scope.hasVoted = true;
                if (scope.bazaarvoiceApiCallEnabled) {
                    scope.responseBazaarVoiceService = BazaarvoiceService.postFeedback({ ContentId: scope.review.reviewId, Vote: (helpful) ? 'Positive' : 'Negative', FeedbackType: 'helpfulness', ReasonText: '' });
                } else {
                    ReviewService.vote({ reviewId: scope.review.reviewId, reportedBy: scope.review.reviewId, helpful });
                }
            };

            scope.report = () => {
                scope.view = CARD_VIEW_MODE.REPORT;
            };

            scope.isReporting = () => {
                return scope.view === CARD_VIEW_MODE.REPORT;
            };

            scope.cancelReport = () => {
                scope.view = CARD_VIEW_MODE.VIEW_ONLY;
            };

            scope.submitReport = (form) => {
                if (form.$valid) {
                    scope.hasReported = true;
                    scope.view = CARD_VIEW_MODE.VIEW_ONLY;
                    if (scope.bazaarvoiceApiCallEnabled) {
                        scope.responseBazaarVoiceService = BazaarvoiceService.postFeedback({ ContentId: scope.review.reviewId, Vote: '', FeedbackType: 'inappropriate', ReasonText: scope.review.report });
                    } else {
                        ReviewService.report({
                            reviewId: scope.review.reviewId,
                            report: scope.review.report
                        });
                    }
                }
            };

            scope.isGuestOrIsOwner = (reviewId) => {
                return (user.isGuest || scope.isOwner(reviewId));
            };

            scope.isOwner = (reviewId) => {
                return ('' + user.id === '' + reviewId);
            };
        }
    };
}

module.exports = ReviewCardDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/cards/review-card-directive.js
 **/